import nspell from 'nspell';

let spellInstance = null;
let initPromise = null;

const initSpellchecker = async () => {
    if (spellInstance) return spellInstance;
    if (initPromise) return initPromise;

    initPromise = (async () => {
        try {
            const [affResponse, dicResponse] = await Promise.all([
                fetch('/dictionaries/en_US.aff'),
                fetch('/dictionaries/en_US.dic')
            ]);

            if (!affResponse.ok || !dicResponse.ok) {
                throw new Error('Failed to fetch dictionary files');
            }

            const affData = await affResponse.text();
            const dicData = await dicResponse.text();

            spellInstance = nspell({
                aff: affData,
                dic: dicData
            });

            return spellInstance;
        } catch (error) {
            console.error('Spellchecker initialization failed:', error);
            initPromise = null; // Reset promise so we can try again
            throw error;
        }
    })();

    return initPromise;
};

export default {
    async isCorrect(word, ignoredWords = new Set()) {
        try {
            const s = await initSpellchecker();
            const cleanWord = word.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "").trim();
            if (!cleanWord) return true;
            if (ignoredWords.has(cleanWord.toLowerCase())) return true;
            return s.correct(cleanWord);
        } catch (e) {
            return true; // Fallback to correct on error
        }
    },

    async getSuggestions(word) {
        try {
            const s = await initSpellchecker();
            const cleanWord = word.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "").trim();
            return s.suggest(cleanWord);
        } catch (e) {
            return [];
        }
    }
};
